// extracted by mini-css-extract-plugin
module.exports = {"legend":"LegendStocking_legend__2ViGk","item":"LegendStocking_item__3hfhf","colorBox":"LegendStocking_colorBox__2M-VC","stockingName":"LegendStocking_stockingName__GjTW6"};